"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
var ui_1 = require("./ui");
var Arrow = function (props) {
    var isExpanded = props.isExpanded, ifShow = props.ifShow, style = props.style, otherProps = __rest(props, ["isExpanded", "ifShow", "style"]);
    if (!ifShow) {
        return React.createElement(ui_1.ArrowSpan, { style: __assign({ visibility: 'hidden' }, style) }, "\u25B6");
    }
    var ownStyle = isExpanded
        ? { transform: 'rotate(90deg)' }
        : { transform: 'rotate(0deg)' };
    var _style = __assign({}, style, ownStyle);
    return (React.createElement(ui_1.ArrowSpan, __assign({}, otherProps, { style: _style }), "\u25B6"));
};
exports["default"] = Arrow;
